export default __webpack_public_path__ + "static/floor3-slide-2-31d1900faad5935d32cc74eec988a50c.jpg";